// @ts-nocheck
import {
    FORM_CLEAR_WARNING_SEEN
} from '../constants/eventForm';

const initialState = {
    formClearWarningSeen: false,
};

const eventFormMetadataReducer = (state = initialState, action) => {
    switch (action.type) {
        
        case FORM_CLEAR_WARNING_SEEN:
            return {
                ...state,
                formClearWarningSeen: true
            }

        default:
            return state;
    }
};
  
export { eventFormMetadataReducer, initialState };
  